/**
 * Detalle al pasar el puntero o al enfocar con teclado.
 *
 * Sustituye al atributo `title` nativo, que es lo que había y que falla en
 * tres cosas que aquí importan:
 *
 *  · tarda alrededor de un segundo en aparecer, y quien recorre una tabla de
 *    treinta filas no espera un segundo por fila
 *  · **no se muestra al enfocar con teclado**: para quien navega con tabulador
 *    la información sencillamente no existe
 *  · no se puede estilar ni contiene más de una línea de texto plano
 *
 * Es el patrón que Recuperos usa junto a su detalle de circuito: poder ver en
 * qué paso está una notificación **sin salir de la lista**.
 *
 * El `TooltipProvider` se monta una vez en `App.tsx`; aquí solo se compone.
 */
import type { ReactElement, ReactNode } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@mpfn/ui'

interface Props {
  /** Lo que se muestra al posarse. Admite varias líneas. */
  ayuda: ReactNode
  /** El elemento que la dispara. Recibe el `ref` del disparador. */
  children: ReactElement
  lado?: 'top' | 'right' | 'bottom' | 'left'
}

export function ConAyuda({ ayuda, children, lado = 'top' }: Props) {
  return (
    <Tooltip>
      {/* `asChild` evita envolver en un botón: el disparador es el propio
          elemento, y así no se añade un tabulable extra por cada chip. */}
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={lado} className="sigfisc-ayuda">
        {ayuda}
      </TooltipContent>
    </Tooltip>
  )
}
